import { Component, OnDestroy, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { Subscription } from 'rxjs'
import { AudioAlarmService } from '../../services/audio-alarm.service'
import { AlarmService } from '../../services/alarm.service'
import { TimeFormatter } from '../../utils/time-formatter'
import { LogService } from 'htv-lib'
import { ALARM_CONFIG } from '../../constants/alarm.constants'
import { RouterService, RouterPage } from '../../services/router.service'

@Component({
  selector: 'app-alarm-ringing',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, TranslateModule],
  templateUrl: './alarm-ringing.component.html',
  styleUrls: ['./alarm-ringing.component.scss'],
})
export class AlarmRingingComponent implements OnInit, OnDestroy {
  currentTime = new Date()
  private timeInterval?: number
  private subscriptions = new Subscription()

  constructor(
    private audioAlarmService: AudioAlarmService,
    private alarmService: AlarmService,
    private logService: LogService,
    private routerService: RouterService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.updateTime()
    this.startAlarmSound()
  }

  ngOnDestroy(): void {
    this.audioAlarmService.stopAlarm()
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
    }
    this.subscriptions.unsubscribe()
  }

  private updateTime(): void {
    this.currentTime = new Date()
    this.timeInterval = window.setInterval(() => {
      this.currentTime = new Date()
    }, ALARM_CONFIG.INTERVALS.TIME_UPDATE_MS)
  }

  private startAlarmSound(): void {
    this.audioAlarmService.startAlarm().catch(error => {
      this.logService.error(`Could not start alarm sound: ${error}`)
    })
  }

  stopAlarm(): void {
    this.audioAlarmService.stopAlarm()

    const alarm = this.alarmService.lastTriggeredAlarm
    if (!alarm?.id) {
      this.alarmService.clearLastTriggeredAlarmTime()
      this.navigateToAlarmSetup()
      return
    }

    this.subscriptions.add(
      this.alarmService.deleteAlarm(alarm.id).subscribe({
        next: () => {
          this.alarmService.clearLastTriggeredAlarmTime()
          this.navigateToAlarmSetup()
        },
        error: err => {
          this.logService.error(`Failed to delete alarm: ${err}`)
          this.alarmService.clearLastTriggeredAlarmTime()
          this.navigateToAlarmSetup()
        },
      })
    )
  }

  private navigateToAlarmSetup(): void {
    this.routerService.goToPage(RouterPage.WAKE_UP_ALARM)
  }

  get formattedTime(): string {
    return TimeFormatter.formatTime(this.currentTime)
  }

  get formattedDate(): string {
    return TimeFormatter.formatDate(this.currentTime)
  }
}
